export default __webpack_public_path__ + "acac04bd10830377da7c6f421a7345c5.svg";